import React, { useEffect } from "react";
import { Button, Card, Col, Divider, Rate, Row } from "antd";
import TrackImage from "../../assets/track-overview.png";
import CheckImage from "../../assets/check.png";
import CourseTypeImage from "../../assets/about-course-icons/courseType.png";
import EndTimeImage from "../../assets/about-course-icons/endTime.png";
import LangImage from "../../assets/about-course-icons/lang.png";
import MultiCoursesImage from "../../assets/about-course-icons/multiCourses.png";
import OnlineImage from "../../assets/about-course-icons/online.png";
import ShareAwardImage from "../../assets/about-course-icons/shareAward.png";
import TimeRequeirImage from "../../assets/about-course-icons/timeRequeir.png";
import TrainerImage from "../../assets/trainer.png";

import "./index.scss";
import {
  ClockCircleOutlined,
  FieldTimeOutlined,
  RadarChartOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getOneCourseById } from "../../store/apis/courses";
import { useNavigate } from "react-router-dom";

function CourseOverview() {
  const courseState = useSelector((state) => state?.courses?.course);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const courseId = window.location.pathname.split("/")[2];
    dispatch(getOneCourseById(courseId));
  }, []);

  const renderCourseHead = () => {
    return (
      <div className="course-overview-head">
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="head-description">
              <h2> {courseState?.title} </h2>
              <div className="rate-desc">
                <Rate disabled value={courseState?.courseRating} />
                <p>{courseState?.courseRating} نجوم</p>
              </div>
              <Button
                type="primary"
                onClick={() =>
                  navigate(`/course-view/${courseState?._id}?step=1-1`)
                }
              >
                ابدأ التعلم
              </Button>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="head-image">
              <img
                src={
                  courseState?.thumnil != ""
                    ? `https://golancer.tech/admin/file/${courseState?.thumnil}`
                    : TrackImage
                }
                crossorigin="anonymous"
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const renderAboutCourse = () => {
    const courseData = [
      {
        title: "مواعيد نهائية مرنة",
        subTitle: "أعد تعيين المواعيد النهائية وفقًا لجدولك الزمني.",
        image: EndTimeImage,
      },
      {
        title: "شهادة قابلة للمشاركة",
        subTitle: "احصل على شهادة عند الانتهاء",
        image: ShareAwardImage,
      },
      {
        title: "100 % أون لاين",
        subTitle: "ابدأ فورًا وتعلم وفقًا لجدولك الخاص.",
        image: OnlineImage,
      },
      {
        title: "دورة 7 في 1 من",
        subTitle: "برمجة تطبيقات الهواتف الذكية بإستخدام فلاتر",
        image: MultiCoursesImage,
      },
      {
        title: "مستوى مبتدئ",
        subTitle: "",
        image: CourseTypeImage,
      },
      {
        title: "تقريبا. 18 ساعة للإكمال",
        subTitle: "",
        image: TimeRequeirImage,
      },
      {
        title: "باللغة العربية",
        subTitle: "",
        image: LangImage,
      },
    ];

    return (
      <div className="about-course-container">
        <div className="about-course-box">
          <h2> حول هذه الدورة </h2>
        </div>
        <Row>
          <Col xs={24} sm={24} md={16} lg={16} xl={16}>
            <div className="about-course-description">
              <p> {courseState?.description} </p>
              <div className="what-you-learn-container">
                <h2> ماذا سوف تتعلم </h2>
                <div className="what-you-learn">
                  <div className="what-you-learn-box">
                    <p>
                      حدد المسؤوليات الوظيفية المشتركة لمصممي UX للمبتدئين
                      والفرق الأخرى التي قد تعمل معها.
                    </p>
                    <img src={CheckImage} />
                  </div>
                  <div className="what-you-learn-box">
                    <p>
                      اشرح لماذا تعتبر سباقات التصميم جزءًا مهمًا ومفيدًا من عمل
                      مصمم UX.
                    </p>
                    <img src={CheckImage} />
                  </div>
                  <div className="what-you-learn-box">
                    <p>
                      فهم المفاهيم الأساسية في تصميم تجربة المستخدم ، مثل
                      التصميم الذي يركز على المستخدم ، وعملية التصميم ، وإمكانية
                      الوصول ، والتصميم الذي يركز على الإنصاف.
                    </p>
                    <img src={CheckImage} />
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <div className="about-course-settings">
              {courseData.map((item) => {
                return (
                  <div className="settings-item">
                    <img src={item.image} />
                    <div className="settings-item-box">
                      <h2> {item.title} </h2>
                      <p> {item.subTitle} </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const renderAboutTrainer = () => {
    return (
      <div className="about-trainer">
        <Row>
          <Col xs={24} sm={24} md={12} lg={8} xl={8}>
            <div className="about-trainer-image">
              {courseState?.trainerImage && (
                <img
                  src={`https://golancer.tech/admin/file/${courseState?.trainerImage}`}
                  crossOrigin="anonymous"
                />
              )}
              <div className="about-trainer-image-desc">
                {/* <span> {courseState?.trainer} </span> */}
                <span>م. محمد الطويل</span>
                {/* <p> مدير التسويق والمبيعات بشركة أكسون موبيل سابقًا </p> */}
                {/* <p>
                  5,343,786 متعلم <br />
                  247 دورة
                </p> */}
              </div>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={16} xl={16}>
            <div className="about-trainer-description">
              <h2> عن المدرب </h2>
              {/* <p> {courseState?.aboutTrainer} </p> */}
              <p>
                محمد مهندس برمجيات ولديه 5 سنوات من الخبرة في تطوير برمجيات
                الهواتف الذكية عمل كمهندس مستقل وبنى مشاريع لشركات وأفراد في دول
                متعددة مثل كندا والمملكة العربية السعودية. الدورات التدريبية
              </p>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const renderCoursesTrack = () => {
    const coursesStudy = [
      {
        courseWeek: "1",
        courseTitle: "مقدمة في تطوير الواجهة الخلفية",
        courseDescription:
          "يركز مصممو تجربة المستخدم (UX) على التجربة التي يتمتع بها المستخدمون أثناء استخدام منتجات مثل مواقع الويب والتطبيقات والأشياء المادية. يجعل مصممو UX تلك التفاعلات اليومية مفيدة وممتعة ويمكن الوصول إليها. في الجزء الأول من هذه الدورة ، ستتعرف على عالم UX والعوامل التي تساهم في تصميم تجربة مستخدم رائعة. ستفهم وظيفة مصمم UX والفرق التي يعمل معها مصممو UX غالبًا. ستتعرف أيضًا على المزيد حول التوقعات المتعلقة بشهادة تصميم Google UX.",
        courseSubDescription:
          "18 مقطع فيديو (إجمالي 61 دقيقة) ، 13 قراءة ، 4 اختبارات",
        courseTimeRequire: "7 ساعات لإكمال",
      },
      {
        courseWeek: "2",
        courseTitle: "مقدمة في تطوير الواجهة الخلفية",
        courseDescription:
          "يركز مصممو تجربة المستخدم (UX) على التجربة التي يتمتع بها المستخدمون أثناء استخدام منتجات مثل مواقع الويب والتطبيقات والأشياء المادية. يجعل مصممو UX تلك التفاعلات اليومية مفيدة وممتعة ويمكن الوصول إليها. في الجزء الأول من هذه الدورة ، ستتعرف على عالم UX والعوامل التي تساهم في تصميم تجربة مستخدم رائعة. ستفهم وظيفة مصمم UX والفرق التي يعمل معها مصممو UX غالبًا. ستتعرف أيضًا على المزيد حول التوقعات المتعلقة بشهادة تصميم Google UX.",
        courseSubDescription:
          "9 مقاطع فيديو (إجمالي 39 دقيقة) ، 5 قراءات ، 3 اختبارات قصيرة",
        courseTimeRequire: "ساعتان للإكمال",
      },
      {
        courseWeek: "3",
        courseTitle: "مقدمة في تطوير الواجهة الخلفية",
        courseDescription:
          "يركز مصممو تجربة المستخدم (UX) على التجربة التي يتمتع بها المستخدمون أثناء استخدام منتجات مثل مواقع الويب والتطبيقات والأشياء المادية. يجعل مصممو UX تلك التفاعلات اليومية مفيدة وممتعة ويمكن الوصول إليها. في الجزء الأول من هذه الدورة ، ستتعرف على عالم UX والعوامل التي تساهم في تصميم تجربة مستخدم رائعة. ستفهم وظيفة مصمم UX والفرق التي يعمل معها مصممو UX غالبًا. ستتعرف أيضًا على المزيد حول التوقعات المتعلقة بشهادة تصميم Google UX.",
        courseSubDescription:
          "10 مقاطع فيديو (إجمالي 27 دقيقة) ، 3 قراءات ، 6 اختبارات قصيرة",
        courseTimeRequire: "4 ساعات لإكمال",
      },
      {
        courseWeek: "4",
        courseTitle: "مقدمة في تطوير الواجهة الخلفية",
        courseDescription:
          "يركز مصممو تجربة المستخدم (UX) على التجربة التي يتمتع بها المستخدمون أثناء استخدام منتجات مثل مواقع الويب والتطبيقات والأشياء المادية. يجعل مصممو UX تلك التفاعلات اليومية مفيدة وممتعة ويمكن الوصول إليها. في الجزء الأول من هذه الدورة ، ستتعرف على عالم UX والعوامل التي تساهم في تصميم تجربة مستخدم رائعة. ستفهم وظيفة مصمم UX والفرق التي يعمل معها مصممو UX غالبًا. ستتعرف أيضًا على المزيد حول التوقعات المتعلقة بشهادة تصميم Google UX.",
        courseSubDescription:
          "10 مقاطع فيديو (إجمالي 36 دقيقة) ، 6 قراءات ، 4 اختبارات قصيرة",
        courseTimeRequire: "5 ساعات لإكمال",
      },
    ];

    return (
      <div className="course-study-container">
        <div className="course-study-section-title">
          <h2> المنهج - ماذا ستتعلم من هذه الدورة </h2>
        </div>
        {courseState?.flowSteps && courseState?.flowSteps.length ? (
          courseState?.flowSteps?.map((item) => {
            return (
              <div className="course-step">
                <Row>
                  <Col
                    xs={24}
                    sm={24}
                    md={2}
                    lg={2}
                    xl={2}
                    className="course-study-description-ant-Col"
                  >
                    <div className="course-study-title">
                      <p> الأسبوع </p>
                      <span> {item.week} </span>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={20} lg={20} xl={20}>
                    <div className="course-study-description">
                      <div className="course-study-time">
                        <ClockCircleOutlined />
                        <span>{item.hoursNeeded}</span>
                      </div>
                      <h3> {item.title} </h3>
                      <p>{item.description}</p>
                      {/* <div className="course-study-time">
                        <RadarChartOutlined />
                        <span>{item.courseSubDescription}</span>
                      </div> */}
                    </div>
                  </Col>
                </Row>
              </div>
            );
          })
        ) : (
          <div>
            <span> No Details For This Course !!! </span>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="course-overview-container">
      {renderCourseHead()}
      {renderAboutCourse()}
      {renderAboutTrainer()}
      {renderCoursesTrack()}
    </div>
  );
}

export default CourseOverview;
